<template>
	<div>
		<p v-if="$tera.project.TrialWizard.dissemination">
			{{ selectRandom(["The dissemination policy for the trial includes ", "The trial's dissemination policy incorporates ","Dissemination policy includes "]) }}
			{{ $tera.project.TrialWizard.dissemination }}
		</p>
		<p v-if="$tera.project.TrialWizard.guidelines">
			{{ selectRandom(["Authorship eligibility guidelines include ", "The guidelines for authorship eligibility include ", "Eligibility for authorship is guided by criteria that include "]) }}
			{{ $tera.project.TrialWizard.guidelines }}
		</p>
		<p v-if="$tera.project.TrialWizard.plans">
			{{ selectRandom(["Plans for granting public access to the full protocol, participant-level dataset, and statistical code include ", "Public access to the full protocol, participant-level dataset, and statistical code will be facilitated through ", "The full protocol, participant-level dataset, and statistical code will be made publicly available via "]) }}
			{{ $tera.project.TrialWizard.plans }}
		</p>
	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputDissemination",
	mixins: [OutputMixin]
};
</script>
